module.exports = __webpack_public_path__ + "static/media/image-8.408ea2e7.png";